import { render } from "./api-reference-card.vue?vue&type=template&id=12e29ada&scoped=true"
import script from "./api-reference-card.vue?vue&type=script&lang=js"
export * from "./api-reference-card.vue?vue&type=script&lang=js"

import "./api-reference-card.vue?vue&type=style&index=0&id=12e29ada&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e29ada"]])

export default __exports__